import { MESSAGE_TYPES } from './constants';

// Régua do guia Visor: micro de 150 ms com a curva de entrada.
const ENTRY_DURATION_MS = 150;
const REDUCED_ENTRY_DURATION_MS = 120;
const ENTRY_EASING = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

export const messageRenderKey = message =>
  String(message?.echoId ?? message?.echo_id ?? message?.id);

export const messageEntryDirection = message => {
  const messageType = message?.messageType ?? message?.message_type;
  if (messageType === MESSAGE_TYPES.INCOMING) return 'left';
  if ([MESSAGE_TYPES.OUTGOING, MESSAGE_TYPES.TEMPLATE].includes(messageType)) {
    return 'right';
  }
  return null;
};

export const classifyMessageListChange = ({
  previousState,
  conversationId,
  messages,
  enabled,
  historyReady,
}) => {
  const keys = messages.map(messageRenderKey);
  const nextState = { conversationId, enabled, historyReady, keys };
  const hasStableContext =
    previousState?.enabled &&
    enabled &&
    previousState.historyReady &&
    historyReady &&
    previousState.conversationId === conversationId;
  const isAppend =
    hasStableContext &&
    keys.length > previousState.keys.length &&
    previousState.keys.every((key, index) => keys[index] === key);

  if (!isAppend) return { nextState, enteringKeys: [] };

  const enteringKeys = messages
    .slice(previousState.keys.length)
    .filter(message => messageEntryDirection(message))
    .map(messageRenderKey);
  return { nextState, enteringKeys };
};

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const runMessageEntryMotion = (
  element,
  direction,
  reduceMotion = prefersReducedMotion()
) => {
  if (!direction || typeof element?.animate !== 'function') return null;

  const offset = direction === 'left' ? '-4px' : '4px';
  const keyframes = reduceMotion
    ? [{ opacity: 0.72 }, { opacity: 1 }]
    : [
        { opacity: 0, transform: `translateX(${offset})` },
        { opacity: 1, transform: 'translateX(0)' },
      ];
  const animation = element.animate(keyframes, {
    duration: reduceMotion ? REDUCED_ENTRY_DURATION_MS : ENTRY_DURATION_MS,
    easing: ENTRY_EASING,
    fill: 'both',
  });
  animation.addEventListener('finish', () => animation.cancel(), {
    once: true,
  });
  return animation;
};
